import FableousLogo from "./FableousLogo";
import FableousTitle from "./FableousTitle";

export default function FableousLogoTitle({maxHeight} : {maxHeight? : number}){
    return (
        <>
            <div><FableousLogo maxHeight={maxHeight}/></div>
            <div><FableousTitle maxHeight={maxHeight ? maxHeight/4 : undefined}/></div>
        </>
    )
}